import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Row,
  Col,
  Select,
  Button,
  Flex,
  Spin,
  message,
} from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import ReactQuill from "react-quill";
import orderService from "../../services/OrderLists";
import "react-quill/dist/quill.snow.css";
import TextArea from "antd/es/input/TextArea";

const { Option } = Select;

const EditTask = ({ orderData, fetchOrderDetails, handleModalClose }) => {
  console.log(orderData,"orderData")
  const [loading, setLoading] = useState(true);
  const [form] = Form.useForm();
  const [selectedRadio, setSelectedRadio] = useState(null);
  const [isFormSubmitiing, setIsFormSubmtting] = useState(false);
  const [dropdownData, setDropdownData] = useState({
    qualities: [],
    status: [],
    references: [],
  });

  const [formData, setFormData] = useState({
    title: orderData.data.title,
    description: orderData.data.description,
    writer_words: orderData.data.writer_word_count || 0, // Default to 0 if undefined
    tags: orderData.data.tags || [], // Default to empty array if undefined
    referencing_style: orderData.data.referencing_style || null, // Default to null
    quality_needed: orderData.data.quality
      ? parseInt(orderData.data.quality, 10)
      : null, // Ensure it's an integer or null
    status: orderData.data.status ? parseInt(orderData.data.status, 10) : null, // Ensure it's an integer or null
    change_reason: "",
  });

  const handleSubmit = async () => {
    const taskKey = orderData.data.key; // Get the taskKey from orderData

    // Create a new object to hold updated data
    const updatedData = { ...formData, taskKey };
console.log(updatedData,"updatedData")
    setIsFormSubmtting(true);
    // No remapping for status, use formData.status directly

    try {
      const response = await orderService.editTask(taskKey, updatedData);
      if (response.success) {
        message.success("Order Edited Successfully");
        fetchOrderDetails();
        handleModalClose();
      }
    } catch (error) {
      setIsFormSubmtting(false);
    } finally {
      setIsFormSubmtting(false);
    }
  };


  const handleRadioChange = (value) => {
    setSelectedRadio(value);
    setFormData((prevData) => ({
      ...prevData,
      quality_needed: parseInt(value, 10),
    })); // Convert to integer
  };

  useEffect(() => {
    const fetchDropdownData = async () => {
      setLoading(true);
      try {
        const qualityData = await orderService.getQualitiesDropdown();
        const statusData = await orderService.getStatusList();
        const referenceData = await orderService.getReferenceDropdown();
        const qualities = Object.entries(qualityData.data).map(
          ([key, value]) => ({
            key,
            value,
          })
        );

        const status = Object.entries(statusData.data.data).map(
          ([key, value]) => ({
            key: parseInt(key, 10),
            value: String(value),
          })
        );

        // Find the key for the quality in orderData
        let initialQualityKey = qualities.find(
          (option) => option.value === orderData.data.quality
        )?.key;

        // If not found (i.e., orderData.data.quality is null), use the first quality key
        if (!initialQualityKey && qualities.length > 0) {
          initialQualityKey = qualities[0].key;
        }

        setSelectedRadio(initialQualityKey);
        setFormData((prev) => ({
          ...prev,
          quality_needed: parseInt(initialQualityKey, 10),
        }));

        setDropdownData({
          qualities,
          status,
          references: referenceData.data,
        });

        // Find the status key by matching the value (string) to orderData.data.status
        let matchedStatus = status.find(
          (option) =>
            String(option.value).toLowerCase() === String(orderData.data.status).toLowerCase()
        );
        // If not found, fallback to first status
        let initialStatusKey = matchedStatus ? matchedStatus.key : (status[0]?.key ?? null);
        setFormData((prev) => ({
          ...prev,
          status: initialStatusKey,
        }));
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDropdownData();
  }, [orderData.data]);

  const handleDescriptionChange = (value) => {
    setFormData((prevData) => ({ ...prevData, description: value }));
  };

  return (
    <>
      {loading ? (
        <Flex justify="center" style={{ width: "100%" }}>
          <Spin />
        </Flex>
      ) : (
        <Form
          style={{ width: "100%" }}
          form={form}
          layout="vertical"
          encType="multipart/form-data"
        >
          <Row gutter={16} style={{ width: "100%" }}>
            <Col sm={24}>
              <Form.Item label="Title" required>
                <Input
                  placeholder="Type Title here"
                  value={formData.title}
                  onChange={(e) =>
                    setFormData({ ...formData, title: e.target.value })
                  }
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16} style={{ width: "100%" }}>
            <Col xs={24}>
              <Form.Item label="Description" >
                <ReactQuill
                  value={formData.description}
                  onChange={handleDescriptionChange}
                  style={{ height: "150px" }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16} style={{ marginTop: "3rem", width: "100%" }}>
            <Col lg={8}>
              <Form.Item label="Client's Word Count">
                <Input
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  pattern="\d*"
                  placeholder="Word count"
                  value={formData.writer_words}
                  suffix={
                    <FileTextOutlined
                      style={{ color: "rgba(0, 0, 0, 0.25)" }}
                    />
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      setFormData({
                        ...formData,
                        writer_words: value,
                      });
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col lg={8}>
              <Form.Item label="Referencing Style">
                <Select
                  placeholder="Select referencing style"
                  onChange={(value) => {
                    setFormData({ ...formData, referencing_style: value }); // Store the selected ID
                  }}
                  value={formData.referencing_style}
                >
                  {dropdownData.references.map((ref) => (
                    <Option key={ref.id} value={ref.id}>
                      {ref.style}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col lg={8}>
              <Form.Item label="Status">
                <Select
                  placeholder="Select Status"
                  onChange={(value) => {
                    setFormData({ ...formData, status: value }); // Store the selected ID
                  }}
                  value={formData.status}
                >
                  {dropdownData.status.map((statusItem) => (
                    <Option key={statusItem.key} value={statusItem.key}>
                
                      {statusItem.value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16} style={{ marginTop: "14px", width: "100%" }}>
            <Col xs={24} sm={24}>
              <Form.Item label="Tags">
                <Select
                  mode="tags"
                  style={{ width: "100%" }}
                  placeholder="Type a tag and press Enter"
                  value={formData.tags}
                  onChange={(tags) =>
                    setFormData((prev) => ({ ...prev, tags }))
                  }
                  tokenSeparators={[","]}
                  open={false}
                />
              </Form.Item>
            </Col>
          </Row>

          <div
            style={{ margin: "20px 0", position: "relative", left: "-10px" }}
          >
            <label style={{ color: "black", marginLeft: "10px" }} aria-required>
              Select Quality
            </label>
            <div className="custom-radio-container">
              {dropdownData.qualities.map((option) => (
                <div
                  key={option.key}
                  style={{
                    marginTop: "10px",
                    position: "relative",
                    left: "10px",
                  }}
                >
                  <input
                    type="radio"
                    id={`custom-radio-${option.key}`}
                    name="quality"
                    value={option.key}
                    className="custom-radio-input"
                    checked={selectedRadio === option.key}
                    onChange={() => handleRadioChange(option.key)} // Store the selected ID
                  />
                  <label
                    style={{ padding: "3px 2px" }}
                    htmlFor={`custom-radio-${option.key}`}
                    className="custom-radio-label"
                  >
                    {option.value}
                  </label>
                </div>
              ))}
            </div>
          </div>

          <Row gutter={16} style={{ marginTop: "18px", width: "100%" }}>
            <Col sm={24}>
              <Form.Item label="Reason" required>
                <Input.TextArea
                  placeholder="Enter the reason"
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      change_reason: e.target.value,
                    })
                  }
                  rows={4} // Adjust the number of rows as needed
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "end",
              margin: "10px",
            }}
          >
            <Button
              onClick={handleSubmit}
              type="primary"
              htmlType="submit"
              loading={isFormSubmitiing} // Show loading state on submit
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      )}
    </>
  );
};

export default EditTask;
